function init() {

    var dropdowns = [];


    var currentHash = "";
    var type = $("#collection-filters").attr("data-collection-tag");
    var refresh = function (page) {


        var query = type == "All" ? [] : [ "product_type:" + type];

        page = page || 1;
        var hash = {page: page};

        $.each(dropdowns, function (_, d) {

            var state = d.state();
            if (state.length) {
                hash[d.name] = state.join("|");
            }
            query = $.merge(query, d.filters());
        });

        var state = "#" + $.param(hash);
        currentHash = state;

        window.location.hash = state;


        if (!query.length)
            query = ["*"];
        $.ajax({
            url: "/search",
            data: "type=product&q=" + query.join("%20") + "&view=json&page="+page,

            dataType: "html",

            success: function (data) {
                $("#collection-products").fadeOut("slow", function () {
                    $(this).replaceWith($(data)).hide().fadeIn("slow");
                })
            }
        });
    };

    $("body").delegate(".paginate a", 'click', function () {
        var params = extractParams($(this).attr("href").split("?")[1]);
        var page = parseInt(params.page, 10);
        refresh(page);
        return false;
    });


    var filterByName = {};
    $(".wrapper-dropdown").each(function () {

        var filter = new FilterMenu($(this), refresh);
        filterByName[filter.name] = filter;
        dropdowns.push(filter);
    });
    function extractParams(value) {
        var result = {}, keyValuePairs = value.split('&');

        keyValuePairs.forEach(function (keyValuePair) {
            keyValuePair = keyValuePair.split('=');
            result[keyValuePair[0]] = keyValuePair[1] || '';
        });

        return result;
    }


    if (!Array.prototype.forEach) {
        Array.prototype.forEach = function (fn, scope) {
            for (var i = 0, len = this.length; i < len; ++i) {
                fn.call(scope, this[i], i, this);
            }
        }
    }


    var onHashChanged = function () {
        currentHash = window.location.hash;
        var state = extractParams(currentHash.replace("#", ""));
        var page = parseInt(state.page, 10) || 1;
        var restored = false;
        $.each(state, function (key, value) {
            var filter = filterByName[key];
            if (filter) {
                filter.restore(value.split("|"));
                restored = true;
            }
        })
        if (restored || page > 1) {
            refresh(page);
        }
    }
    if (window.location.hash.length) {
        onHashChanged();
    }


    $(window).hashchange(onHashChanged);
}

var FilterMenu = function ($el, changeHandler) {
    this.$el = $el;
    this.onChange = changeHandler;
    this.name = $el.attr("data-filter");

    this.init();

}
FilterMenu.prototype = {


    restore: function (selection) {
        var $el = this.$el;
        $.each(selection, function (_, value) {
            $el.find(':checkbox[value="' + value + '"]').attr("checked", true);
        });
    },
    init: function () {
        var self = this;
        this.$el.find("span").click(function () {
            self.$el.toggleClass("open");
            return false;
        })
        var timeout;
        this.$el.hover(function () {
            clearTimeout(timeout);
        }, function () {
            if (self.$el.hasClass("open")) {
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    self.$el.toggleClass("open");
                }, 500);

            }
        })
        this.$el.find(":checkbox").change($.proxy(this.dispatch, this));
    },
    dispatch: function () {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.onChange, 200);
    },
    checked: function () {
        return  this.$el.find(":checkbox:checked");
    },
    state: function () {
        return $.map(this.checked(), function (input) {
            return $(input).val();
        });

    },
    filters: function () {
        var filters = [];
        this.checked().each(function () {
            filters = $.merge(filters, $.map($(this).val().split("/"), function (tag) {
                return "tag:" + tag;
            }));
        });
        return filters;

    }

};


$(init);

/*
 * jQuery hashchange event - v1.3 - 7/21/2010
 * http://benalman.com/projects/jquery-hashchange-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function ($, e, b) {
    var c = "hashchange", h = document, f, g = $.event.special, i = h.documentMode, d = "on" + c in e && (i === b || i > 7);

    function a(j) {
        j = j || location.href;
        return"#" + j.replace(/^[^#]*#?(.*)$/, "$1")
    }

    $.fn[c] = function (j) {
        return j ? this.bind(c, j) : this.trigger(c)
    };
    $.fn[c].delay = 50;
    g[c] = $.extend(g[c], {setup: function () {
        if (d) {
            return false
        }
        $(f.start)
    }, teardown: function () {
        if (d) {
            return false
        }
        $(f.stop)
    }});
    f = (function () {
        var j = {}, p, m = a(), k = function (q) {
            return q
        }, l = k, o = k;
        j.start = function () {
            p || n()
        };
        j.stop = function () {
            p && clearTimeout(p);
            p = b
        };
        function n() {
            var r = a(), q = o(m);
            if (r !== m) {
                l(m = r, q);
                $(e).trigger(c)
            } else {
                if (q !== m) {
                    location.href = location.href.replace(/#.*/, "") + q
                }
            }
            p = setTimeout(n, $.fn[c].delay)
        }

        $.browser.msie && !d && (function () {
            var q, r;
            j.start = function () {
                if (!q) {
                    r = $.fn[c].src;
                    r = r && r + a();
                    q = $('<iframe tabindex="-1" title="empty"/>').hide().one("load",function () {
                        r || l(a());
                        n()
                    }).attr("src", r || "javascript:0").insertAfter("body")[0].contentWindow;
                    h.onpropertychange = function () {
                        try {
                            if (event.propertyName === "title") {
                                q.document.title = h.title
                            }
                        } catch (s) {
                        }
                    }
                }
            };
            j.stop = k;
            o = function () {
                return a(q.location.href)
            };
            l = function (v, s) {
                var u = q.document, t = $.fn[c].domain;
                if (v !== s) {
                    u.title = h.title;
                    u.open();
                    t && u.write('<script>document.domain="' + t + '"<\/script>');
                    u.close();
                    q.location.hash = v
                }
            }
        })();
        return j
    })()
})(jQuery, this);